"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAfmExecution = exports.convertResultSpec = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var FilterConverter_1 = require("./FilterConverter");
var MeasureConverter_1 = require("./MeasureConverter");
var sdk_model_1 = require("@gooddata/sdk-model");
var ObjRefConverter_1 = require("../ObjRefConverter");
function convertAttribute(attribute, idx) {
    var alias = attribute.attribute.alias;
    var aliasProp = alias ? { alias: alias } : {};
    return tslib_1.__assign({ displayForm: ObjRefConverter_1.toBearRef(attribute.attribute.displayForm), localIdentifier: attribute.attribute.localIdentifier || "a" + (idx + 1) }, aliasProp);
}
function convertAFM(def) {
    var attributes = def.attributes.map(convertAttribute);
    var attrProp = attributes.length ? { attributes: attributes } : {};
    var measures = def.measures.map(MeasureConverter_1.convertMeasure);
    var measuresProp = measures.length ? { measures: measures } : {};
    var filters = FilterConverter_1.convertFilters(def.filters);
    var filtersProp = filters.length ? { filters: filters } : {};
    var nativeTotals = convertNativeTotals(def);
    var nativeTotalsProp = nativeTotals.length ? { nativeTotals: nativeTotals } : {};
    return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, measuresProp), attrProp), filtersProp), nativeTotalsProp);
}
function convertNativeTotals(def) {
    // first find all native totals defined across dimensions
    var nativeTotals = def.dimensions
        .map(sdk_model_1.dimensionTotals)
        .reduce(function (acc, totals) { return acc.concat.apply(acc, totals); }, [])
        .filter(sdk_model_1.totalIsNative);
    return nativeTotals.map(function (t) {
        // then for each native total, look across buckets (if any) for an attribute that is specified in
        // the total definition
        var attributeInDims = sdk_model_1.dimensionsFindItem(def.dimensions, t.attributeIdentifier);
        if (!attributeInDims.length) {
            throw new Error("Native total references attribute that is not in any dimension: " + t.attributeIdentifier);
        }
        else if (attributeInDims.length > 1) {
            throw new Error("Native total references attribute that is in multiple dimensions: " + t.attributeIdentifier);
        }
        var attributeDim = attributeInDims[0];
        // now, knowing the dimension and index of the attribute.. roll up all attributes that are before it
        var rollupAttributes = attributeDim.dim.itemIdentifiers
            .slice(0, attributeDim.itemIdx)
            .filter(function (id) { return id !== sdk_model_1.MeasureGroupIdentifier; });
        // and create native total such, that it rolls up all those attributes
        return {
            measureIdentifier: t.measureIdentifier,
            attributeIdentifiers: rollupAttributes,
        };
    });
}
function convertTotals(totals) {
    if (totals === void 0) { totals = []; }
    return totals.map(function (t) {
        return {
            type: t.type,
            attributeIdentifier: t.attributeIdentifier,
            measureIdentifier: t.measureIdentifier,
        };
    });
}
function convertDimensions(def) {
    return def.dimensions.map(function (dim) {
        var totals = convertTotals(dim.totals);
        var totalsProp = !isEmpty_1.default(totals) ? { totals: totals } : {};
        return tslib_1.__assign({ itemIdentifiers: dim.itemIdentifiers }, totalsProp);
    });
}
function convertResultSpec(def) {
    var sortsProp = !isEmpty_1.default(def.sortBy) ? { sorts: def.sortBy } : {};
    var dims = convertDimensions(def);
    var dimsProp = !isEmpty_1.default(dims) ? { dimensions: dims } : {};
    return tslib_1.__assign(tslib_1.__assign({}, sortsProp), dimsProp);
}
exports.convertResultSpec = convertResultSpec;
// This has to be const function, otherwise api-extractor breaks...
/**
 * Converts execution definition to AFM Execution
 *
 * @param def - execution definition
 * @returns AFM Execution
 *
 * @internal
 */
exports.toAfmExecution = function (def) {
    return {
        execution: {
            afm: convertAFM(def),
            resultSpec: convertResultSpec(def),
        },
    };
};
//# sourceMappingURL=ExecutionConverter.js.map